import React from "react"

import LocalTime from "components/LocalTime"

import DeleteClassPeriod from "./DeleteClassPeriod"
import EditClassPeriod from "./EditClassPeriod"

export type AcrClassPeriod = {
  id: string
  startsAt: string
  endsAt: string
}

type ClassPeriodsListProps = {
  periods: AcrClassPeriod[]
  timeZone: string
  ianaTimeZone: string
}

const ClassPeriodsList: React.FC<ClassPeriodsListProps> = ({
  periods,
  timeZone,
  ianaTimeZone,
}) => {
  if (periods.length === 0) {
    return <p className="italic">No periods generated yet.</p>
  }

  return (
    <table className="table-striped table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Time</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {periods.map(period => (
          <tr key={period.id}>
            <td>
              <LocalTime format="ddd ll" timestamp={period.startsAt} />
            </td>
            <td>
              <LocalTime omitDate timestamp={period.startsAt} />
              &nbsp;&mdash;&nbsp;
              <LocalTime omitDate timestamp={period.endsAt} />
            </td>
            <td className="space-x-2">
              {new Date(period.endsAt).getTime() > Date.now() && (
                <EditClassPeriod
                  period={period}
                  timeZone={timeZone}
                  ianaTimeZone={ianaTimeZone}
                />
              )}
              {new Date(period.startsAt).getTime() > Date.now() && (
                <DeleteClassPeriod periodId={period.id} />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default ClassPeriodsList
